export { default } from './wishlist-counter-button';